import React from 'react';
export const initialFilterState = {
    applyListFilter: () => { },
    applyRangeFilter: () => { },
    applyBoolFilter: () => { },
    applyMultiFilter: () => { },
    applyFilters: () => { },
    activeFilters: {
        listFilters: [],
        rangeFilters: [],
        booleanFilters: [],
        multiListFilters: []
    },
    clearFilters: () => { },
    clearListFilter: () => { },
    location: undefined,
    unmounted: true
};
const FilterContext = React.createContext(initialFilterState);
export default FilterContext;
//# sourceMappingURL=FilterContext.js.map